export const filterArray = (item) => item !== undefined && item !== ""